<app-langding-page-nav-bar></app-langding-page-nav-bar>

<div class="container faq-container-f783" style="margin-top: 83px;">

  <div class="panel-body faq-header-f783">
    <h2 class="faq-main-title-f783">
      FAQ
    </h2>
  </div>

  <div class="faq-layout-f783">
    <!-- Left Sidebar Menu -->
    <div class="faq-sidebar-f783">
      <div class="faq-sidebar-panel-f783">
        <ul class="faq-nav-list-f783">
          <li class="faq-nav-item-f783"
              [class.active]="title=='General'"
              (click)="clickitem('General',1)">
            <a class="faq-nav-link-f783">
              <div class="faq-nav-icon-f783">
                <ng-icon name="tablerHelp"></ng-icon>
              </div>
              <span class="faq-nav-text-f783">General</span>
            </a>
          </li>
          <li class="faq-nav-item-f783"
              [class.active]="title=='Referral FAQ'"
              (click)="clickitem('Referral FAQ',2)">
            <a class="faq-nav-link-f783">
              <div class="faq-nav-icon-f783">
                <ng-icon name="tablerUsers"></ng-icon>
              </div>
              <span class="faq-nav-text-f783">Referral FAQ</span>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Right Content Area -->
    <div class="faq-content-f783">
      <div class="faq-content-panel-f783">
        <h4 class="faq-section-title-f783">{{title}}</h4>

        <div class="faq-content-body-f783">
          <app-common-skeleton *ngIf="loadAPIcall" [countforView]="15" [NameOftheScreen]="'faq'"></app-common-skeleton>

          <!-- Custom Accordion - Modern Design -->
          <div class="custom-accordion-f783" *ngIf="title!='Credit Consumption-Matrix' && !loadAPIcall">
            <div class="accordion-item-f783" *ngFor="let data of faqresponse?.faqList; let i = index">
              <div class="accordion-header-f783"
                   [class.active]="activeAccordionIndex === i"
                   (click)="toggleAccordion(i)">
                <span class="accordion-question-f783">{{data.question}}</span>
                <ng-icon name="tablerChevronDown" class="accordion-icon-f783" [class.rotated]="activeAccordionIndex === i"></ng-icon>
              </div>
              <div class="accordion-content-f783"
                   [class.expanded]="activeAccordionIndex === i">
                <div class="accordion-body-f783">
                  <span [innerHTML]="data?.answer"></span>
                </div>
              </div>
            </div>
          </div>



        <ng-container *ngIf="title=='Credit Consumption-Matrix'">

          <div>
            <div class="col-sm-6">
              <div style="margin-top: 20px;">
                <div class="table-responsive">
                  <table class="table table-bordered ">
                    <thead>
                      <tr>
                        <th class="faq-table-align faq-tableheader">POST</th>
                        <th class="faq-table-align faq-tableheader"> Credits Consumed
                          <br>
                          <span style="font-size: 10px;"> (daily per active job /candidate)</span>
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="faq-table-align-value">Job </td>
                        <td class="faq-table-align" > {{getelement(getName.CREATE_JOB)?.points}} </td>

                      </tr>
                      <tr>
                        <td class="faq-table-align-value">Candidate </td>
                        <td class="faq-table-align">{{getelement(getName.CREATE_CANDIDATE)?.points}}</td>

                      </tr>

                    </tbody>
                  </table>
                </div>



              </div>


              <div style="margin-top: 20px;">
                <div class="table-responsive">
                  <table class="table table-bordered ">
                    <thead>
                      <tr>
                        <th class="faq-table-align faq-tableheader">VIEW</th>
                        <th class="faq-table-align faq-tableheader"> Credits Consumed
                          <br>
                          <span style="font-size: 10px;"> (1st time the activity is performed)</span>
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="faq-table-align-value"> Job </td>
                        <td class="faq-table-align"> {{getelement(getName.JOB_VIEW)?.points}}</td>
                      </tr>
                      <tr>
                        <td class="faq-table-align-value"> Supplier Candidate </td>
                        <td class="faq-table-align"> {{getelement(getName.VIEW_CANDIDATE)?.points}} </td>
                      </tr>
                      <tr>
                        <td class="faq-table-align-value"> Jobseeker </td>
                        <td class="faq-table-align"> {{getelement(getName.CANDIDATE_INVITE_JOB_SEEKER)?.points}} </td>
                      </tr>
                    </tbody>

                  </table>
                </div>
              </div>


              <div style="margin-top: 20px;">
                <div class="table-responsive">
                  <table class="table table-bordered ">
                    <thead>
                      <tr>
                        <th class="faq-table-align faq-tableheader">INVITE </th>
                        <th class="faq-table-align faq-tableheader"> Credits Consumed
                          <br>
                          <span style="font-size: 10px;"> (per invite sent)</span>
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="faq-table-align-value">Supplier Candidate </td>
                        <td class="faq-table-align"> {{getelement(getName.VIEW_CANDIDATE)?.points}}</td>
                      </tr>
                      <tr>
                        <td class="faq-table-align-value"> Jobseeker </td>
                        <td class="faq-table-align"> {{getelement(getName.CANDIDATE_INVITE_JOB_SEEKER)?.points}} </td>
                      </tr>
                    </tbody>

                  </table>
                </div>
              </div>


              <div style="margin-top: 20px;">
                <div class="table-responsive">
                  <table class="table table-bordered ">
                    <thead>
                      <tr>
                        <th class="faq-table-align faq-tableheader">Request Resume </th>
                        <th class="faq-table-align faq-tableheader"> Credits Consumed
                          <br>
                          <span style="font-size: 10px;"> (per request sent)</span>
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="faq-table-align-value">Supplier candidate Resume</td>
                        <td class="faq-table-align"> {{getelement(getName.VIEW_CANDIDATE)?.points}}</td>
                      </tr>
                      <tr>
                        <td class="faq-table-align-value"> Jobseeker Resume </td>
                        <td class="faq-table-align"> {{getelement(getName.CANDIDATE_INVITE_JOB_SEEKER)?.points}} </td>
                      </tr>
                    </tbody>

                  </table>
                </div>
              </div>




            </div>


            <div class="col-sm-6">

              <div style="margin-top: 20px;">
                <div class="table-responsive">
                  <table class="table table-bordered ">
                    <thead>
                      <tr>
                        <th class="faq-table-align faq-tableheader">UPGRADE</th>
                        <th class="faq-table-align faq-tableheader"> Credits Consumed
                          <br>
                          <span style="font-size: 10px;"> (daily per active upgraded job /candidate)</span>
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="faq-table-align-value">Job </td>
                        <td class="faq-table-align"> {{getelement(getName.UPGRADED_JOB)?.points}}</td>
                      </tr>
                      <tr>
                        <td class="faq-table-align-value">Candidate </td>
                        <td class="faq-table-align">{{getelement(getName.UPGRADE_CANDIDATE)?.points}}</td>
                      </tr>
                    </tbody>

                  </table>
                </div>
              </div>


              <div style="margin-top: 20px;">
                <div class="table-responsive">
                  <table class="table table-bordered ">
                    <thead>
                      <tr>
                        <th class="faq-table-align faq-tableheader">APPLY</th>
                        <th class="faq-table-align faq-tableheader"> Credits Consumed
                          <br>
                          <span style="font-size: 10px;"> (per job applied)</span>
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="faq-table-align-value">Client Job </td>
                        <td class="faq-table-align"> {{getelement(getName.JOB_APPLY)?.points}}</td>
                      </tr>
                      <tr>
                        <td class="faq-table-align-value">SI Job </td>
                        <td class="faq-table-align">{{getelement(getName.SI_JOB_APPLY)?.points}}</td>
                      </tr>

                      <tr>
                        <td class="faq-table-align-value">Prime Vendor/ Staffing Agency </td>
                        <td class="faq-table-align">{{getelement(getName.PRIME_VENDORE)?.points}}</td>
                      </tr>


                      <tr>
                        <td class="faq-table-align-value">Vendor Job </td>
                        <td class="faq-table-align">{{getelement(getName.VENDOR_JOB_APPLY)?.points}}</td>
                      </tr>

                      <tr>
                        <td class="faq-table-align-value">Freelancer Job </td>
                        <td class="faq-table-align">{{getelement(getName.FREELANCER_JOB_APPLY)?.points}}</td>
                      </tr>

                    </tbody>

                  </table>
                </div>
              </div>






            </div>

          </div>

        </ng-container>

        </div>
      </div>
    </div>
  </div>
</div>
